import { ImgHTMLAttributes, useEffect, useState } from "react";
import NoIMG from "../../App/Assets/Images/empty.png";

interface Props extends ImgHTMLAttributes<any> {
  fallback?: string;
}

export default function ImageWithFallback({
  fallback = NoIMG,
  src,
  style,
  ...props
}: Props) {
  const [imgSrc, setImgSrc] = useState<string | undefined>(src);

  useEffect(() => {
    setImgSrc(src);
  }, [src]);

  const onError = () => setImgSrc(fallback);

  return (
    <img
      src={imgSrc ? imgSrc : fallback}
      onError={onError}
      {...props}
      alt=""
      style={{
        marginTop: "1rem",
        objectFit: "cover",
        borderRadius: "0.5rem",
        ...style,
      }}
    />
  );
}
